import * as swcHelpers from '@swc/helpers';
import { isEveryLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { toDrafts } from '../../server/to-drafts.js';
import { toOrderLineItem } from '../line-item/order-line-item.js';
import '@grandvisionhq/utils';
import { getPaymentMethodLabel } from '../utils/get-payment-method-label.js';
import { getPaymentStatusLabel } from '../utils/get-payment-status-label.js';
import { isSupportedLineItem } from '../utils/order-line-item-product-type-guards.js';
import '@grandvisionhq/graphql';
import { getShipmentStatusLabel } from '../utils/get-shipment-status-label.js';
import { getOrderStatusLabel } from '../utils/get-order-status-label.js';
import { toAddress, toOrderDetailPrice } from './orders.js';

const toOrderDetails = (order, intl, options = {})=>{
    if (!order) {
        return undefined;
    }
    const lineItems = order.lineItems.filter(isSupportedLineItem);
    var ref, _receiptUrl, _shipmentTrackingURL, _paymentStatus;
    return swcHelpers.objectSpread({
        billingAddress: toAddress(order.billingAddress),
        shippingInfo: order.shippingInfo.deliveryMethodName,
        drafts: toDrafts(lineItems),
        isReorderAvailable: isEveryLineItemReorderable(lineItems),
        lineItems: lineItems.map(toOrderLineItem.bind(null, intl, options)),
        orderDate: new Date(order.orderDate),
        orderNumber: order.orderNumber,
        paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
        paymentStatus: (ref = getPaymentStatusLabel(order.paymentStatus, intl)) !== null && ref !== void 0 ? ref : '',
        isReturnable: order.returnStatus === 'RETURNABLE',
        receiptUrl: (_receiptUrl = order.receiptUrl) !== null && _receiptUrl !== void 0 ? _receiptUrl : undefined,
        shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
        orderStatus: getOrderStatusLabel(order.state, intl),
        shipmentTrackingUrl: (_shipmentTrackingURL = order.shipmentTrackingURL) !== null && _shipmentTrackingURL !== void 0 ? _shipmentTrackingURL : undefined,
        shippingAddress: toAddress(order.shippingAddress),
        rawPaymentStatus: (_paymentStatus = order.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : '',
        customerDetails: {
            email: order.customerDetails.email
        }
    }, toOrderDetailPrice(order.price));
};

export { toOrderDetails };
//# sourceMappingURL=order-details.js.map
